import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Div, Gutter, Title } from '@gaiads/telia-react-component-library';
import { UserResponse, UserGroupResponse } from '@cdaas/api-clients/dist/asset-admin-openapi';

import EditAdministrator from './EditAdministrator/EditAdministrator';
import { AdministratorItem } from './AdministratorItem/AdministratorItem';
import { WithKey } from '../../../utils';

export default function Administrators({
  administrators,
  userGroups,
  currency,
  onAdminCreate,
  onAdminUpdate,
  onGroupCreate,
}: {
  administrators: WithKey<UserResponse>[];
  userGroups: UserGroupResponse[];
  currency: string;
  onAdminCreate: (administrator: UserResponse) => void;
  onAdminUpdate: (administrator: UserResponse) => void;
  onGroupCreate: (group: WithKey<UserGroupResponse>) => void;
}) {
  const { t } = useTranslation('organizationForm');

  const [isAddAdministratorShown, setIsAddAdministratorShown] = useState(false);

  const handleAdminCreate = (administrator: UserResponse) => {
    onAdminCreate(administrator);
    setIsAddAdministratorShown(false);
  };

  return (
    <Div padding={{ size: 'lg' }} boxShadow="md">
      <Title size={'sm'}>{t('administrators.administratorsHeading')}</Title>
      <Gutter />
      {administrators.map((administrator, key) => (
        <AdministratorItem
          key={`administrator-${key}`}
          administrator={administrator}
          userGroups={userGroups}
          currency={currency}
          onAdminUpdate={onAdminUpdate}
          onGroupCreate={onGroupCreate}
        />
      ))}
      {!isAddAdministratorShown ? (
        <Button variant="secondary" onClick={() => setIsAddAdministratorShown(true)}>
          {t('administrators.addAdministratorButton')}
        </Button>
      ) : (
        <EditAdministrator
          userGroups={userGroups}
          currency={currency}
          onCancel={() => setIsAddAdministratorShown(false)}
          onAdminUpdate={handleAdminCreate}
          onGroupCreate={onGroupCreate}
        />
      )}
    </Div>
  );
}
